<template>
  <div
    :class="embed ? 'fixed bottom-0 left-0 right-0 z-20 bg-surface-light' : ''"
  >
    <div :class="embed ? 'p-4 border-t border-surface-grey' : ''">
      <BaseButton :class="embed ? 'w-full' : 'mb-4'" color="primary" :disabled="!cart.pdfReady" @click="openModal">
        <TicketIcon class="fill-current w-6 h-6 mr-2" />
        <span v-if="loading">{{ $t('checkout.loading_pdf') }}</span>
        <span v-else>{{ $t('checkout.download_your_tickets') }}</span>
      </BaseButton>
    </div>
  </div>

  <BaseModal v-model="modal">
    <template #header>{{ $t('checkout.download_tickets') }}</template>

    <div class="p-6 space-y-4">
      <a
        :href="cart.pdfLink"
        target="_blank"
        class="p-4 font-semibold flex justify-between items-center border border-surface-grey rounded-md hover:opacity-50 transition"
      >
        {{ $t('checkout.download_tickets_as_pdf') }}
        <DownloadIcon class="w-8 h-8" />
      </a>
      <div v-if="cart.ReceiptConfirmPayment.passbook && cart.ReceiptConfirmPayment.passbook.link">
        <a :href="cart.ReceiptConfirmPayment.passbook.link" target="_blank" class="inline-block hover:opacity-50">
          <img :src="cart.ReceiptConfirmPayment.passbook.atpblink" alt="Add to Apple Wallet" class="h-12 w-auto" />
          <!-- <img src="/images/apple-wallet.png" alt="Apple wallet" /> -->
        </a>
        <p class="text-sm mt-6">Scan QR og få dine billetter på mobilen</p>
        <div v-if="cart.ReceiptConfirmPayment.passbook.qr_code" class="mt-2 hidden md:block">
          <img :src="cart.ReceiptConfirmPayment.passbook.qr_code" alt="Apple Wallet QR code" class="w-32 h-32" />
        </div>
      </div>
      <div class="text-sm">
        {{ $t('checkout.your_tickets_are_also_sent_to') }}
        <b>{{ cart.receiptOrder.info.email }}</b>
      </div>
    </div>
  </BaseModal>
</template>

<script setup lang="ts">
  import { ref } from 'vue';

  import { useCartStore } from '@/stores/cart';
  import { isEmbed } from '@/utils/isEmbed';

  import DownloadIcon from '../icons/DownloadIcon.vue';
  import TicketIcon from '../icons/TicketIcon.vue';
  import BaseButton from '../ui/BaseButton.vue';
  import BaseModal from '../ui/BaseModal.vue';

  const modal = ref(false);
  const loading = ref(false);
  const cart = useCartStore();
  const embed = isEmbed();

  function openModal() {
    // Only open modal if PDF is ready, otherwise try again in 0.5s
    if (cart.pdfReady) {
      modal.value = true;
      loading.value = false;
    } 
    else {
      loading.value = true;
      setTimeout(openModal, 500);
    }
  }
  
</script>
